module.exports = __webpack_public_path__ + "static/hbo2-b476d0673c997ca4e1179f409811f686.png";